import { render, staticRenderFns } from "./ProjectChats.vue?vue&type=template&id=07d7a782&scoped=true&"
import script from "./ProjectChats.vue?vue&type=script&lang=js&"
export * from "./ProjectChats.vue?vue&type=script&lang=js&"
import style0 from "./ProjectChats.vue?vue&type=style&index=0&id=07d7a782&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d7a782",
  null
  
)

export default component.exports